jQuery(document).ready(function ($) {
  const ANIMATE_TIME = 300;

  // accordions
  $(".accordion-heading").on("click", function (e) {
    e.preventDefault();
    var $this = $(this);

    if (!$this.parent().hasClass("accordion-open")) {
      $(".accordion-content").slideUp(300);
      $(".accordion-heading").removeClass("accordion-open");
    }

    $this.parent().toggleClass("accordion-open");
    $this.next().slideToggle(300);
  });

  // mobile nav
  const overlay = $(".c-mobile-menu");

  $(".mobile-nav__toggle").click(function (e) {
    $(this).toggleClass("mobile-open");
    overlay.toggleClass("mobile-open hidden");
  });

  // general dropdowns
  function closeHidden() {
    $(".expanded")
      .removeClass("expanded")
      .next(".hidden")
      .slideToggle(ANIMATE_TIME);
  }

  $(".trigger").on("click", function () {
    const isOpen = $(this).hasClass("expanded");

    if (isOpen) {
      closeHidden();
      return;
    }

    closeHidden();

    $(this).addClass("expanded").next(".hidden").slideToggle(ANIMATE_TIME);
  });

  // newsletter modal
  const modal = $('.newsletter-modal');
  const close = $('.modal-close');

  modal.hide();

  const COOKIE_DAYS = 30;

  let cookie = localStorage.getItem('feronia-subscribe');

  if (cookie == undefined || cookie == null) {
    cookie = 0;
  }

  const currentTime = new Date().getTime();
  const popupShouldShow =
    (currentTime - cookie) / (1000 * 60 * 60 * 24) > COOKIE_DAYS;

  function openModal() {
    modal.fadeIn(300);
  }

  function closeModal() {
    modal.addClass("u-hidden");
    localStorage.setItem('feronia-subscribe', currentTime);
    console.log(localStorage);
  }

  close.click(function (e) {
    closeModal();
  })

  if (popupShouldShow) {
    setTimeout(() => {
      openModal();
    }, 2000);
  }
});
